import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { Avatar, Chip, IconButton, Modal, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import { FETCH_CLIENT_SAFETY_OBSERVATION } from "../../constant/Apipath";
import ClientSafetyObservationAddModal from "./ClientSafetyObservationAddModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { ClientUDFieldComponent } from "./ClientUDFieldComponent";

export const ClientSafetyObservationViewModal = ({
  isOpen,
  onClose,
  data,
  reLoadData,
  from,
  SARid,
  dueDate
}) => {
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [dueDateForEdit, setDueDateForEdit] = useState(0);
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const TOKEN = loginData?.accessToken;
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const [loading, setLoading] = useState(false);
  const LANGUAGE = ClientEnglishFallback.ClientSafetyObservationViewModal(multiLanguageData?.ClientSafetyObservationViewModal || {})
  const {
    TEXT_ME,
    TEXT_JOB,
  } = LANGUAGE;
  useEffect(() => {
    if (from == "SAR") {
      setDueDateForEdit(dueDate);
    }
    if (isOpen) {
      fetchClientSafetyObs();
    }
  }, [isOpen]);

  const [addModel, setAddModel] = useState(false);
  const [clientSafetyObs, setClientSafetyObs] = useState({});

  const fetchClientSafetyObs = async () => {
    setLoading(true);
    let payload = {
      PageNr: 1,
      NrOfRecPerPage: 1,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [
        {
          FieldName: "Id",
          Direction: "DESC"
        }
      ],
      SearchList: [{ id: data?.id }]
    };
    try {
      let response = await Postrequestcall(FETCH_CLIENT_SAFETY_OBSERVATION, payload, TOKEN);
      setLoading(false);

      if (response.status == 200) {
        let res = response.data.data;
        if (res?.length > 0) {
          setClientSafetyObs(res[0]);
        }
      }
    } catch (error) {
      console.log("fetchClientSafetyObs-> Error Fetching Client Safety Observation: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <div className="client-modal-responsive">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="action-button-container">
                <IconButton sx={{color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }} onClick={() => onClose()}>
                  <CloseIcon />
                </IconButton>
                {selectedClientData?.ClientEmployeeId === data.clientEmployeeId &&
                  dueDateForEdit < 48 && (
                    <IconButton onClick={() => setAddModel(true)}>
                      <EditIcon
                        style={{
                          color: CLIENT_ACCENT_COLOR
                        }}
                      />
                    </IconButton>
                  )}
              </div>
              <Stack
                sx={{ display: "flex",  padding: {
                  xs: 0,
                  sm: 0,
                  md: 1,
                  lg: 2,
                  xl: 2
                 }}}
                
                gap={2}>
                <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction="row" spacing={2}>
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
                    <Avatar src={clientSafetyObs?.profilePictureUrl} />
                    <Typography variant="body1">
                      {clientSafetyObs.userName}{" "}
                      {selectedClientData?.ClientEmployeeId ===
                        clientSafetyObs.clientEmployeeId && (
                          <span
                            style={{
                              color: BIGrey,
                              fontSize: "0.8rem"
                            }}>
                            {TEXT_ME}
                          </span>
                        )}
                    </Typography>
                  </Stack>
                  <Typography
                    style={{
                      color: BIGrey,
                      fontSize: ".9rem"
                    }}>
                    {dayjs(clientSafetyObs?.safetyObservationDate).format("MMMM DD, YYYY")}
                    {clientSafetyObs?.isEdited ? " *" : ""}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    style={{
                      color: BIGrey,
                      fontSize: "1rem"
                    }}>
                    {TEXT_JOB}
                  </Typography>
                  <Typography>{`${clientSafetyObs?.clientJobCode} ${clientSafetyObs?.clientJobName}`}</Typography>
                </Stack>
                <Stack>
                  <Typography
                    sx={{
                      maxHeight: "70px",
                      wordBreak: "break-all",
                      overflow: "auto"
                    }}>
                    {clientSafetyObs?.description}
                  </Typography>
                </Stack>
                <Stack
                  style={{
                    scrollbarWidth: "none"
                  }}
                  sx={{ display: "flex" }}
                  direction={"row"}
                  gap={1}
                  overflow={"scroll"}>
                  {clientSafetyObs?.pictureList?.map((item, index) => (
                    <div key={index}>
                      <img
                        onClick={() => {
                          setPictureViewerOpen(true);
                          setImageIndex(clientSafetyObs?.pictureList?.indexOf(item));
                        }}
                        src={item?.fileUrl}
                        alt="img"
                        style={{
                          cursor: "pointer",
                          width: "100px",
                          height: "100px",
                          borderRadius: "5px"
                        }}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </Stack>

                <ClientUDFieldComponent mode="view" udFields={clientSafetyObs?.udFieldsList} />
              </Stack>
            </>
          )}
        </div>
      </Modal>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        pictures={clientSafetyObs?.pictureList?.map((item) => ({
          src: item?.fileUrl,
          alt: ""
        }))}
        viewerIndex={imageIndex}
      />
      <ClientSafetyObservationAddModal
        isOpen={addModel}
        onClose={() => setAddModel(false)}
        data={clientSafetyObs}
        setData={setClientSafetyObs}
        mode="edit"
        from={from}
        SARid={SARid}
        reLoadData={() => {
          reLoadData();
          onClose();
        }}
      />
    </>
  );
};
